import { isEmpty, merge } from "lodash";
import { IVariaveisAmbiente, IAmbienteUnico } from "./types";
import { EnumDeviceType } from "../model/enums/enum-device-type";

const AmbienteEnviado = (process.env.REACT_APP_ENV || "mpProd") as keyof IVariaveisAmbiente;
const AmbientePadrao: keyof IVariaveisAmbiente = AmbienteEnviado;
const LabelEnviado = (process.env.REACT_APP_LABEL || "Touchone") as keyof IVariaveisAmbiente;

// const apiUrl = 'https://api-gateway.touchone.com.br';


export const getEnvironment = (): `prodWeb` | `devWeb` => {
  const environment = (process.env.REACT_APP_ENV || "prodWeb") as `prodWeb` | `devWeb`;
  return environment
}

export const getChaveAtivacaoRevenda = () => {
  const chaveAtivacaoRevendaStorage = localStorage.getItem('environments-chaveAtivacaoRevenda');
  if (!chaveAtivacaoRevendaStorage) {
    const chaveAtivacaoRevendaDefault = (process.env.REACT_APP_ATIVACAO || "");
    localStorage.setItem('environments-chaveAtivacaoRevenda', chaveAtivacaoRevendaDefault);
    return isEmpty(chaveAtivacaoRevendaDefault) ? undefined : chaveAtivacaoRevendaDefault;
  }
  return chaveAtivacaoRevendaStorage;
}

const enviroment = getEnvironment()

const ambiente = enviroment === 'prodWeb' ? 'prod' : 'staging'

const apiUrl = `https://api-gateway-${ambiente}.touchone.com.br`
const apiSetoresUrl = `https://api-setores-${ambiente}.touchone.com.br`
const apiPedidosUrl = `https://api-pedidos-${ambiente}.touchone.com.br`

const gatewayVersion = 'v6';
const setoresVersion = 'v5';
const pedidosVersion = 'v2';

let apiGoogleKey = 'AIzaSyDCn6uvO-lB1P4kOTa9kDrcCBbJqxJs2Rc'

if (enviroment === 'devWeb')
  apiGoogleKey = 'AIzaSyDCn6uvO-lB1P4kOTa9kDrcCBbJqxJs2Rc'

// variáveis de ambiente(óbvio)

const _variaveisAmbiente: IVariaveisAmbiente = {
  all: {
    version: "1.1.3.8",
    isDev: (["prodWeb"].find(x => x === AmbientePadrao.toString())?.length || 0) === 0,
    environment: AmbienteEnviado,
    googleAppId: "27279191635-5kdincvmbm92lihatr0k4tm1o4kon8ue.apps.googleusercontent.com",
    saurusUtilsWebService: "https://wsmaster.saurus.net.br/v003/servicemaster.asmx",
    label: LabelEnviado,
    packageNamePdv: 'br.com.saurus.touchoneweb',
    packageNameRetaguarda: 'br.com.saurus.touchone.retaguarda',
    packageNameKds: 'br.com.saurus.kds',
  },
  devWeb: {
    apiUrl: apiUrl,
    paymentDevice: Number(process.env.REACT_APP_DEVICE) || EnumDeviceType.NAVIGATOR,
    apiSetoresUrl: apiSetoresUrl,
    apiGoogleKey: 'AIzaSyDCn6uvO-lB1P4kOTa9kDrcCBbJqxJs2Rc',
    apiPedidosUrl: apiPedidosUrl,
    facebookAppId: "661218711269424",
    frontUrl: "https://app.touchone.com.br",
    gatewayVersion: gatewayVersion,
    pedidosVersion: pedidosVersion,
    setoresVersion: setoresVersion,
  },
  prodWeb: {
    apiUrl: apiUrl,
    paymentDevice: Number(process.env.REACT_APP_DEVICE) || EnumDeviceType.NAVIGATOR,
    apiSetoresUrl: apiSetoresUrl,
    apiPedidosUrl: apiPedidosUrl,
    apiGoogleKey: apiGoogleKey,
    facebookAppId: "1880946222051906",
    frontUrl: "https://app.touchone.com.br",
    gatewayVersion: gatewayVersion,
    pedidosVersion: pedidosVersion,
    setoresVersion: setoresVersion,
  },
  chaveAtivacaoRevenda: getChaveAtivacaoRevenda(),
};

const _ambienteUnico =
  (_variaveisAmbiente[AmbientePadrao] as IAmbienteUnico) || _variaveisAmbiente.devWeb || _variaveisAmbiente.chaveAtivacaoRevenda;
export const VariaveisAmbiente = merge(_variaveisAmbiente.all, _ambienteUnico);
